export function setreporte(state, data_report_sales_purchases) {
    state.report_sales_p = data_report_sales_purchases
    //console.log(reporte_comisiones);
}
export function setParams(state, params){
    state.params = params
}
export function setDateRangeParam(state) {

    const fechaActual = new Date(); // Fecha actual

    // Restar un mes a la fecha actual para obtener el mes anterior
    const fechaMesAnterior = restarMesesAFecha(fechaActual, 1);

    // Obtener el primer día del mes anterior
    const primerDiaMesAnterior = new Date(fechaMesAnterior.getFullYear(), fechaMesAnterior.getMonth(), 1);

    // Obtener el último día del mes anterior
    const ultimoDiaMesAnterior = new Date(fechaMesAnterior.getFullYear(), fechaMesAnterior.getMonth() + 1, 0);


    state.params.date = [
        primerDiaMesAnterior,
        ultimoDiaMesAnterior,
    ];

}

export function restarMesesAFecha(fecha, cantidadMeses) {
    const fechaClonada = new Date(fecha);

    // Obtener el mes y año actuales
    const mesActual = fechaClonada.getMonth();
    const anioActual = fechaClonada.getFullYear();

    // Calcular el nuevo mes y año
    let nuevoMes = mesActual - cantidadMeses;
    let nuevoAnio = anioActual;

    // Manejar el cambio de año si el nuevo mes es menor a 0
    while (nuevoMes < 0) {
        nuevoMes += 12;
        nuevoAnio--;
    }

    // Establecer la nueva fecha con los meses restados
    fechaClonada.setMonth(nuevoMes);
    fechaClonada.setFullYear(nuevoAnio);

    return fechaClonada;
}

export function setStatesRadian(state, radiansState) {
    state.radiansState = radiansState;
    radiansState.forEach(item =>{
        state.radiansStateNames.push(item.name_parameter)
    })
}
export function update_row(state, documentInfo) {
    alert('actualiza el documento')
}



// WEBPACK FOOTER //
// ./src/modules/report-sales-purchases/mutations.js